export const FETCH_APPLICATION_LIST = 'application/FETCH_APPLICATION_LIST';
export const FETCH_APPLICATION_LIST_SUCCESS = 'application/FETCH_APPLICATION_LIST_SUCCESS';
export const FETCH_APPLICATION_LIST_ERROR = 'application/FETCH_APPLICATION_LIST_ERROR';

export const FETCH_DETAIL_ERROR = 'application/FETCH_DETAIL_ERROR';
export const UNMOUNT_APPLICATION_DETAIL = 'application/UNMOUNT_APPLICATION_DETAIL';
export const SET_APPLICATIONS_SEARCH_TERM = 'application/SET_APPLICATIONS_SEARCH_TERM';

// Create new Application
export const CREATE_NEW_APPLICATION = 'application/CREATE_NEW_APPLICATION';
export const CREATE_NEW_APPLICATION_ERROR = 'aplication/CREATE_NEW_APPLICATION_ERROR';

// Account Notifications
export const FETCH_NOTIFICATION_LIST = 'application/FETCH_NOTIFICATION_LIST';
export const FETCH_NOTIFICATION_LIST_SUCCESS = 'application/FETCH_NOTIFICATION_LIST_SUCCESS';
export const FETCH_NOTIFICATION_LIST_ERROR = 'application/FETCH_NOTIFICATION_LIST_ERROR';

// Update Account Notification
export const UPDATE_NOTIFICATION = 'application/UPDATE_NOTIFICATION';
export const UPDATE_NOTIFICATION_SUCCESS = 'application/UPDATE_NOTIFICATION_SUCCESS';
export const UPDATE_NOTIFICATION_ERROR = 'application/UPDATE_NOTIFICATION_ERROR';
